import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '@env/environment';
import { StorageService } from '../../helpers/storage/storage.service';
import { AuthResponseDto, TokenDto } from './models/auth-response-dto';

@Injectable({
  providedIn: 'root'
})
export class ApiAuthService {
  
  private readonly token = 'token';

  constructor(private _storage: StorageService, private http: HttpClient) {}

  generateToken(): Observable<AuthResponseDto> {
    const body = {
      keyAccess: environment.apikeys.keyAccess,
      Flag: environment.currentEnviroment
      };
    return this.http
      .post<AuthResponseDto>(`${environment.apiUrl}/access/token`, body)
      .pipe(tap((Response) => this.saveToken(Response.result)));
  }

  getToken(): string | null {
    return this._storage.getItem(this.token);
  }

  hasToken(): boolean {
    return !!this._storage.getItem(this.token);
  }

  private saveToken(TokenDto: TokenDto): void {
    this._storage.setItem(this.token, TokenDto.access_token);
  }

  removeToken(): void {
    this._storage.deleteItem(this.token);
  }
}
